// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"b4eda2bd326cf533bbe6","655":"3453b18337ead3dd1fa0"}[chunkId] + ".js";
};